/**
 * Product names by order id for the Treatments cards. The house build keeps
 * the catalog's display name, so this is empty; the storefront build swaps
 * in src/flavors/rxstore/orderProductNames.ts (vite.config.ts), which reads
 * the order list so a card says "Sermorelin" as Home and Orders do.
 */
export function useOrderProductNames(): {
  names: Map<string, string> | null;
  pending: boolean;
} {
  return { names: null, pending: false };
}
